<div class="h-full">
    <div class="flex flex-row justify-end items-center">
        <button mat-icon-button class="close-button" mat-dialog-close>
            <mat-icon class="close-icon" color="accent">close</mat-icon>
        </button>
    </div>
    <div class="sm:px-6 px-1 bg-white h-full ">
        <!-- <div>
            <h2 class="font-medium text-xl" mat-dialog-title>
                {{ "Response" | translate | async }}
            </h2>
        </div>
        <div class="flex flex-col justify-center items-center">
            <div class="font-bold">Customer review:</div>
            <div [ngClass]="{'hidden': data.comments === undefined || data.comments === null || data.comments === ''}" class="h-[150px] p-2 mt-6 border-2 rounded-lg overflow-auto ml-2">{{data.comments}}</div>
        </div> -->

        <div class="px-4">

            <div class="flex flex-col justify-center items-center border-b-2 border-[#233E80] w-full text-[#233E80]  h-[50px] ">
                <div>
                    <h2 class="text-xl font-bold">
                        {{ "Response" | translate | async }}
                    </h2>
                </div>


            </div>

            <div [ngClass]="{'hidden': data.comments === undefined || data.comments === null || data.comments === ''}"
                class=" mt-4 border-2  border-[#233E80]/70 rounded-lg overflow-auto mx-[10px]   ">
                <div class="flex flex-row justify-center items-center w-full  text-white bg-[#233E80]  p-2 ">
                    <div class="font-bold text-md">{{utils.traslatei18n('Customer review')}}</div></div>
                <div class="mt-4 overflow-auto h-[150px] flex flex-row justify-center items-start w-full ">
                    <div class="px-[10px]">
                        {{data.comments}}                        
                    </div> </div>
            </div>
            <div class=" mt-4">
                <app-dynamic-form *ngIf="formGroup && isLoaded" [formGroup]="formGroup" [inputForm]="inputForm"
                                  [appearanceForm]="'outline'"> </app-dynamic-form>
            </div>

            <div class="w-full my-4" *ngIf="isNewTemplate">
                <div class="flex flex-row justify-center items-center">
                    <button mat-flat-button color="warn" [disabled]="!formGroup.valid" (click)="onDeleteTemplate()"
                            >{{utils.traslatei18n('DeleteTemplate')}}</button>
                </div>

            </div>
            <div class="w-full my-4" *ngIf="inputForm[0][0].value == multiresponse[multiresponse.length - 1]">
                <div class="flex flex-row justify-center items-center">
                    <button mat-flat-button color="accent" [disabled]="!formGroup.valid" (click)="onSaveTemplate()"
                    >{{utils.traslatei18n('SaveTemplate')}}</button>
                </div>
            </div>
            <div class="w-full my-4">
                <div class="flex flex-row justify-center items-center">
                    <button mat-flat-button color="accent" [disabled]="!formGroup.valid" (click)="onSave()"
                            class="w-1/3">{{utils.traslatei18n('PostReply')}}</button>
                </div>
            </div>
        </div>




        <!-- <div class="w-full flex flex-col ">
            <app-dynamic-form class="pt-3" *ngIf="formGroup" [formGroup]="formGroup" [inputForm]="inputForm"
                [appearanceForm]="'outline'">
            </app-dynamic-form>

            <mat-dialog-actions class="justify-between">
                <div class="w-full p-20">
                    <div class="flex flex-row justify-center items-center">
                        <button mat-flat-button color="accent" [disabled]="!formGroup.valid" (click)="onSave()"
                            class="w-1/3">{{utils.traslatei18n('PostReply')}}</button>
                    </div>
                </div>
            </mat-dialog-actions>
        </div> -->
    </div>
</div>